export default __webpack_public_path__ + "media/images/upsell-benefit-icon-white-42c4f9a8.svg";